import { render, staticRenderFns } from "./MenuDivider.vue?vue&type=template&id=196aafcc&"
var script = {}
import style0 from "./MenuDivider.vue?vue&type=style&index=0&id=196aafcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports